import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

/**
 * Component IDs (ordering priority) for the document search action buttons registry.
 * Start with explicit names rather than numbers for clarity; consumers can extend.
 */
enum DocumentSearchActionButtonsComponentId {
    // Reserve first slot for custom buttons inserted before the approve button
    OntarioMdHealthReportManager = 0
}

/**
 * Registry responsible for rendering additional action buttons in the DocumentSearch footer
 * (to the left of the built-in approve button).
 */
class DocumentSearchActionButtonsRegistry extends BaseComponentRegistry<DocumentSearchActionButtonsComponentId> {}

/**
 * React view that renders all registered action buttons.
 */
const DocumentSearchActionButtonsRegistryView = createRegistryListView(() => DocumentSearchActionButtonsRegistry.getInstance());

export {
    DocumentSearchActionButtonsComponentId,
    DocumentSearchActionButtonsRegistry,
    DocumentSearchActionButtonsRegistryView
};
